// Reçete malzeme satırında, birim fiyatın kaynağını gösteren kompakt işaret.
//
// Maliyet servisi (backend costing_service) her satıra bir `kaynak` etiketi koyar
// (TRANSFER, RECETE, MALZEME, IC_SATIS(...), IC_SATIS_FALLBACK, ...). Reçete
// formundaki birim fiyat hücresi bu etiketten küçük bir ibare türetir:
//   - TRANSFER            → "TF"   (transfer fiyatı / dükkan alış)
//   - IC_SATIS(...)       → "SAS"  (gerçek iç satış fiyatı = Şirketler Arası Satış)
//   - IC_SATIS_FALLBACK   → "SAS~" (iç satış kaydı yok → dış fiyat × marka marjı tahmini)
//
// Renkler MaliyetAnalizPage'deki KaynakBadge ile birebir aynı (görsel tutarlılık):
// İÇ SATIŞ #006064, İÇ SATIŞ (TAHMİN) #bf360c, TRANSFER mavisi #1565c0.
//
// NOT: IC_SATIS kaynakları birim çevriminde "÷2(KG→GR)" gibi ek alabilir
// (costing_service), o yüzden eşleşme startsWith ile yapılır. TRANSFER bu eki
// almaz (alt-reçete dalında üretilir) → tam eşleşme korunur (mevcut davranış).

/**
 * @param {string} kaynak - maliyet satırının kaynak etiketi (satirMaliyet.kaynak)
 * @returns {{ etiket: string, renk: string, ipucu: string } | null}
 *   İşaretlenecek kaynaksa rozet bilgisi; değilse null (ibare gösterilmez).
 */
export function getFiyatKaynakRozeti(kaynak) {
  if (!kaynak || typeof kaynak !== 'string') return null;

  if (kaynak === 'TRANSFER') {
    return { etiket: 'TF', renk: '#1565c0', ipucu: 'Transfer Fiyatı (dükkan alış)' };
  }
  // Fallback (iç satış kaydı yok, tahmini) — "(" değil "_" ile devam eder.
  if (kaynak.startsWith('IC_SATIS_FALLBACK')) {
    return {
      etiket: 'SAS~',
      renk: '#bf360c',
      ipucu: 'İç Satış (tahmini — kayıt yok, dış fiyat × marka marjı)',
    };
  }
  // Gerçek iç satış fiyatı: IC_SATIS(FATURA) / IC_SATIS(TRANSFER) (± ÷ birim çevrim eki).
  if (kaynak.startsWith('IC_SATIS(')) {
    return {
      etiket: 'SAS',
      renk: '#006064',
      ipucu: 'İç Satış Fiyatı (Şirketler Arası Satış)',
    };
  }
  return null;
}
